import type { WiwState } from '@/store';

export const getFailed = (state: WiwState) => {
  return state.workchat.failed;
};
